<template>
  <ul class="ba-w-89 ba-pr-2">
    <li
      v-for="({ unread, title, date, description, id, files },
      index) in docmailList"
      :key="index"
      class="ba-w-full ba-mb-2 last:ba-mb-0 ba-px-6 ba-py-5 ba-text-sm ba-bg-white hover:ba-bg-background-primary-weak ba-rounded ba-border-l-2 ba-border-transparent ba-cursor-pointer ba-transition-colors ba-duration-300"
      :class="{
        'ba-bg-background-primary-weak ba-border-accent ba-rounded-l-none':
          selectedMail === index,
      }"
      @click="onItemSelect(id, index)"
    >
      <!-- HEAD ============================= -->
      <div
        class="ba-flex ba-items-center ba-mb-2"
        :class="{ 'ba-text-text-dark-grey': !unread }"
      >
        <span
          v-if="unread"
          class="ba-flex-shrink-0 ba-w-2 ba-h-2 ba-mr-2 ba-rounded-full ba-bg-primary"
        />
        <h4 class="ba-mr-2 ba-font-wellingtons-demibold ba-truncate">
          {{ title }}
        </h4>
        <!-- <p class="ba-ml-auto ba-font-inter-regular ba-whitespace-no-wrap">
          {{ formatDateTime(date) }}
        </p> -->
      </div>

      <!-- DESCRIPTION ============================= -->
      <p class="ba-mb-4 ba-font-wellingtons-medium">{{ description }}</p>

      <div class="ba-flex ba-items-center ba-w-full ba-mt-2" >
        <div>
          <p class="ba-ml-auto ba-font-inter-regular ba-whitespace-no-wrap ba-text-text-dark-grey">
            {{ formatDateTime(date) }}
          </p>
        </div>
        <div v-if="files && files.length > 0" class="ba-flex ba-items-center ba-ml-auto">
          <i class="far fa-paperclip ba-mr-1"></i>
          <span class="ba-font-inter-regular">{{ files.length }}</span>
        </div>
        <!-- <vis-filestorage-chooser
          :value="files"
          :readonly="true"
          :server-api="serverApi"
          :file-handler-api="fileHandlerApiUrl"
          :secureShare="true"
        /> -->
        <!-- DOCUMENTS LIST ============================= -->
        <!-- <div class="ba-flex ba-w-4/5 ba-mr-2">
          <div
            v-for="(item, index) in getDocsShortList(index)"
            :key="index"
            class="ba-flex ba-items-center ba-w-1/2 ba-mr-2 last:ba-mr-0 ba-p-2 ba-border ba-rounded-full ba-select-none"
          >
            <component
              :is="`vis-file-${item.docType}`"
              class="ba-flex-shrink-0 ba-w-4 ba-h-4 ba-mr-2"
            />
            <p
              class="ba-text-xs ba-leading-none ba-font-wellingtons-medium ba-text-accent ba-truncate"
            >
              {{ item.docName }}
            </p>
          </div>
        </div>

        <div class="ba-min-w-8 ba-ml-auto">
          <div
            v-if="documents.length > 2"
            class="ba-flex ba-flex-shrink-0 ba-items-center ba-p-2 ba-border ba-rounded-full ba-select-none"
          >
            <span
              class="ba-text-sm ba-leading-none ba-font-inter-regular ba-text-accent"
              >+{{ documents.length - 2 }}
            </span>
          </div>
        </div> -->
      </div>
      <!-- END RELETIVE DOCUMENTS -->
    </li>
  </ul>
</template>

<script>
import VisFileDoc from "./file-types/vis-file-doc";
import VisFilePdf from "./file-types/vis-file-pdf";
import VisFileDefault from "./file-types/vis-file-default";
import VisFilestorageChooser from "@/views/vis-filestorage-chooser";
import globalState from "@/shared/global-state";
import { formatDateTime } from "@/shared/date";

export default {
  name: "vis-docmail-list-design",
  components: {
    VisFileDoc,
    VisFilePdf,
    VisFileDefault,
    VisFilestorageChooser,
  },
  props: {
    docmailList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedMail: 0,
      serverApi: globalState.launchConfig.fileStorage.serverApiUrl,
      fileHandlerApiUrl: globalState.launchConfig.fileStorage.fileHandlerApiUrl,
    };
  },
  methods: {
    formatDateTime(date) {
      return formatDateTime(date);
    },
    getDocsShortList(files) {
      return (files || "").split(",").filter(function (s) {
        return !!s;
      });
    },
    onItemSelect(id, index) {
      this.selectedMail = index;
      this.$emit("onItemSelect", id);
    },
  },
  created() {},
};
</script>
